/**
 * Regras compartilhadas dos documentos da etapa 2 do Cadastro Trademate.
 *
 * Mesma definição de `isDocumentFulfilled` do trademate.controller.js, que é quem decide o envio:
 * se as duas divergirem, o contador do rodapé libera um botão que o backend recusa (ou o contrário).
 */

/**
 * Se o documento já cumpre o que o envio exige. O gerado precisa do assinado; o complementar, de ao
 * menos um arquivo — RG e CPF aceitam vários (frente e verso), mas um já basta.
 *
 * @param {{complementary: boolean, signed_key: string, files: object[]}} document
 */
export function isDocumentFulfilled(document) {
    return document.complementary
        ? !!(document.files && document.files.length > 0)
        : !!document.signed_key;
}
